const axios = require('axios');
import EventBus from "../api/event-bus";

export function millisToReadable(timestamp) {

  if(timestamp == 0) {
    return "";
  }
  let date = new Date(timestamp);

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  let hh = date.getHours().toString();
  if (hh.length == 1) hh = '0'+hh;

  let minute = date.getMinutes().toString();
  if (minute.length == 1) minute = '0'+minute;

  let second = date.getSeconds().toString();
  if (second.length == 1) second = '0'+second;

  // let today = new Date();
  // if(today.getFullYear().toString() === yy) {
  //   return mm+'.'+dd+' '+hh+':'+minute+':'+second;
  // }
  return date.toLocaleDateString('en-GB', {
    month: 'short', day: 'numeric',  year: 'numeric'
  }) +' at '+hh+':'+minute+':'+second;
  // return yy+'.'+mm+'.'+dd+' '+hh+':'+minute+':'+second;

}

export function generateOrderNumber() {
  let date = new Date();

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  let hh = date.getHours().toString();
  if (hh.length == 1) hh = '0'+hh;

  let minute = date.getMinutes().toString();
  if (minute.length == 1) minute = '0'+minute;

  let second = date.getSeconds().toString();
  if (second.length == 1) second = '0'+second;

  // let today = new Date();
  // if(today.getFullYear().toString() === yy) {
  //   return mm+'.'+dd+' '+hh+':'+minute+':'+second;
  // }
  return yy+mm+dd+hh+minute+second;
}

export function millisToDate(timestamp, splitter = '.') {
  if(timestamp == 0) {
    return "";
  }
  let date = new Date(timestamp);

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;


  return yy + splitter + mm + splitter + dd;

}
export function getTodayDate() {

  let date = new Date();

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;


  return yy + '-' + mm + '-' + dd;

}
export function getFilePathFromTodayDate() {

  let date = new Date();

  //

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;


  return yy + '/' + mm + '/' + dd;

}
export function getStockTypeString(stockType) {
  if(stockType == 0) {
    return '수량';
  } else if(stockType == 1) {
    return '물품';
  }
  return '모름';
}


export function printLabel(barcode, title, description = "", brand = "", price = "", count = 1) {
  return new Promise(function (resolve, reject) {
    let printerUrl = process.env.ROOT_API + 'meta/type/label_printer';
    axios.get(printerUrl, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {
        let data = response.data;
        console.log(data);
        if(data.success == true) {
          let url = data.item.title + "/print.php?barcode=" + barcode + "&title=" + title + "&description=" + description + "&count=" + count + "&brand=" +brand + "&price="+price;
          console.log("print url =  "+ url);
          axios.get(url)
            .then(function (response) {
              let data = response.data;
              resolve(data);
            })
            .catch(function (err) {
              reject(err);
            })
        }
        //resolve(data);
      })
      .catch(function (err) {
        reject(err);
      })




  })
}


export function getStockStateString(state) {
  if(state == 0) {
    return '구매입고';
  } else if(state == 10) {
    return '판매완료';
  } else if(state >= 1 && state <= 9) {
    return '배송중';
  }
  return state;
}


export function getStateList() {
  let states = [
    {
      val:0,
      title:"모든주문",
      orderState:"결제취소",
      selectable:false,
    },
    {
      val:1,
      title:"주문생성",
      orderState:"결제대기",
      selectable:true,
    },
    {
      val:2,
      title:"주문접수",
      orderState:"결제대기",
      selectable:true,
    },
    {
      val:3,
      title:"주문완료",
      orderState:"결제완료",
      selectable:true,
    },
    {
      val:4,
      title:"Order Prepared",
      orderState:"상품준비",
      selectable:false,
    },
    {
      val:5,
      title:"베송시작",
      orderState:"베송시작",
      selectable:true,
    },
    {
      val:6,
      title:"Order on way",
      orderState:"배송중",
      selectable:false,
    },
    {
      val:10,
      title:"배송완료",
      orderState:"배송완료",
      selectable:true,
    },
  ];

  return states;

}
export function getDayStart(day) {
  let date = new Date(day);
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return date.getTime();
}
export function getDayEnd(day) {
  let date = new Date(day);
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return date.getTime();
}
export function getDateString(dayFrom, dayDiff = 0) {
  console.log("getDateString " + dayFrom + " diff " + dayDiff);
  let date = new Date(dayFrom);

  date.setDate(date.getDate() + dayDiff);

  let yy = date.getFullYear().toString();

  let mm = (date.getMonth()+1).toString();
  if (mm.length == 1) mm = '0'+mm;

  let dd = date.getDate().toString();
  if (dd.length == 1) dd = '0'+dd;

  console.log("getDateString returns now " + yy+'-'+mm+'-'+dd);
  return yy+'-'+mm+'-'+dd;
}

export function getDayOfWeek(day) {
  let date = new Date(day);
  return date.getDay();
}
export function getDayOfWeekString(day) {
  if(day == 0) {
    return "SUN";
  } else if(day == 1) {
    return "MON";
  } else if(day == 2) {
    return "TUE";
  } else if(day == 3) {
    return "WED";
  } else if(day == 4) {
    return "THU";
  } else if(day == 5) {
    return "FRI";
  } else if(day == 6) {
    return "SAT";
  }
  return day;
}

export function showDialog(message = '', title = '') {
  let params = {
    title:title,
    text:message
  }
  EventBus.$emit("showDialog", params);
}
export function timeToLocaleDateShort(time) {
  let date = new Date(time);
  return date.toLocaleDateString('en-GB', {
    month: 'short', day: 'numeric',  year: 'numeric'
  });
}
export function timeToLocaleDate(time) {
  let date = new Date(time);
  return date.toLocaleDateString('en-GB', {
    weekday: 'short', month: 'short', day: 'numeric'
  });
}
export function timeToLocaleDateYear(time) {
  let date = new Date(time);
  return date.toLocaleDateString('en-GB', {
    weekday: 'short', month: 'short', day: 'numeric', year: 'numeric'
  });
}
export function setLastPage(path) {
  localStorage.setItem("lastPage", path);
}

export function getShiftList() {
  return [
    {value:0, title:'NA'},
    {value:1, title:'AM'},
    {value:2, title:'PM'}
  ]
}





// WEBPACK FOOTER //
// ./src/api/utils.js